import { Component, OnInit, Input} from '@angular/core';

// env
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-banner-header',
  templateUrl: './banner-header.component.html',
  styles: [
  ]
})
export class BannerHeaderComponent implements OnInit {

  @Input() dataBanner;
  @Input() fontSize;
  apiAsset = environment.API_ASSETS;

  constructor() { }

  ngOnInit(): void {
  }

}
